import script from "./PreSportFeaturedFixtures.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportFeaturedFixtures.vue?vue&type=script&setup=true&lang=js"

import "./PreSportFeaturedFixtures.vue?vue&type=style&index=0&id=bcd9b56a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcd9b56a"]])

export default __exports__